import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { Box, Typography, FormControl, Input, Select, MenuItem } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  mainContainer: ({ isInGroup, isSummary }) => ({
    margin: isInGroup || isSummary ? '40px auto 20px auto' : '20px auto',
    alignItems: 'center',
    width: '100%',
    maxWidth: '650px',
  }),
  heading: {
    color: theme.palette.text.primary,
    fontWeight: 800,
    fontSize: '17px',
  },
  formControlLabels: {
    color: theme.palette.text.primary,
    fontWeight: 300,
    fontSize: '15px',
  },
  dropdown: {
    padding: '12px 15px',
    width: '50px',
    minWidth: '50px',
    maxWidth: '50px',
  },
}));

const initialStateHandle = currency => ({
  currency: currency,
  amount: '',
});

const CurrencyAmount = props => {
  const [currencyValue, setCurrencyValue] = useState(() => initialStateHandle(props.currencies[0].value));

  const classes = useStyles({
    isInGroup: props.isInGroup,
    isSummary: props.isSummary,
  });

  useEffect(() => {
    setCurrencyValue(() => initialStateHandle(props.currencies[0].value));
  }, [props.id]);

  const handleChange = (type, event) => {
    let value;
    if (type === 'amount') {
      value = Math.abs(parseInt(event.target.value)) || '';
    } else {
      value = event.target.value;
    }
    const newState = {
      ...currencyValue,
      [type]: value,
    };
    setCurrencyValue(newState);
    props.handleSurveyAnswers(newState, props.id);
  };

  return (
    <Box className={classes.mainContainer}>
      <Typography component="div" variant="h3" className={classes.heading}>
        {props.heading}
      </Typography>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        style={{ columnGap: '12px', marginTop: '12px', rowGap: '15px', flexWrap: 'wrap' }}>
        <Box display="flex" alignItems="center" justifyContent="flex-start" style={{ columnGap: '12px' }}>
          <Typography component="div" variant="body2" className={classes.formControlLabels}>
            {props.currencyLabel}
          </Typography>
          <Select
            labelId={`dropdown-id-${props.id}`}
            id={`dropdown-id-${props.id}`}
            variant="outlined"
            value={props.value ? props.value.currency : currencyValue.currency}
            onChange={event => handleChange('currency', event)}
            classes={{ root: classes.dropdown }}>
            {props.currencies.map((e, index) => {
              return (
                <MenuItem key={index} value={e.value}>
                  {e.label}
                </MenuItem>
              );
            })}
          </Select>
        </Box>
        <Box display="flex" alignItems="center" justifyContent="flex-start" style={{ columnGap: '12px' }}>
          <Typography component="div" variant="body2" className={classes.formControlLabels}>
            {props.amountLabel}
          </Typography>
          <Input
            id={`input-id-${props.id}`}
            style={{ maxWidth: '120px' }}
            type="number"
            inputProps={{ min: 0 }}
            value={props.value ? props.value.amount : currencyValue.amount}
            onChange={event => handleChange('amount', event)}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CurrencyAmount;
